<script lang="ts">
	import Icon from "@components/common/Icon.svelte";
	import global from "../../../core/assets/icons/global.svg?raw";
	import people from "../../../core/assets/icons/people.svg?raw";
	import services from "../../../core/assets/icons/services.svg?raw";
	import triumph from "../../../core/assets/icons/triumph.svg?raw";
	import { getTranslate } from "../utils/getTranslate.js";
	import translations from "./AboutStats.translations.json" with { type: "json" };

	const translate = getTranslate(translations);

	const statsData = [
		{ icon: triumph, text: translate("experience") },
		{ icon: global, text: translate("global") },
		{ icon: services, text: translate("services") },
		{ icon: people, text: translate("employees") },
	];
</script>

<section class="full-width bg-zms-grey grid-container">
	<div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-5 md:gap-6">
		{#each statsData as stat (stat)}
			<div
				class="bg-white border border-[#efefef] rounded-2xl p-4 sm:p-5 md:p-6 flex flex-row sm:flex-col gap-3 sm:gap-6 md:gap-8 items-center sm:items-start"
			>
				<div class="rounded-full p-3 sm:p-4 bg-zms-blue flex-shrink-0">
					<Icon icon={stat.icon} class="w-6 h-6 sm:w-7 sm:h-7 md:w-8 md:h-8 text-white" square={true} />
				</div>
				<h3 class="text-base sm:text-lg font-medium text-zms-blue-dark">
					{stat.text}
				</h3>
			</div>
		{/each}
	</div>
</section>
